/**
 * @internal
 */
export type Vec2 = {
  x: number;
  y: number;
};

/**
 * Calculates the angle between two vec2.
 * Ranges from -1 to -180 (top quadrant) and 0 to 180 (bottom quadrant).
 * The 0 angles start at the right side with 180 beeing on the left.
 *
 * @internal
 */
export function angleBetweenVec2(c: Vec2, e: Vec2): number {
  /** Calculate direction (difference) vector */
  const dy = e.y - c.y;
  const dx = e.x - c.x;

  /** Use arctan2 to get the angle of the direction vector in radians */
  let theta = Math.atan2(dy, dx);

  /** Calculate to degrees (-1 to -180 and 0 to 180) */
  theta *= 180 / Math.PI;

  return theta;
}

/**
 * @internal
 */
export type AlignmentPosition = 'right' | 'center' | 'left';

/**
 * Calculates the alignment sector based on the angle to the center.
 *
 * @internal
 */
export function getAlignmentPosition(angle: number): AlignmentPosition {
  // 0 - 34 = left, 35 - 145 center, 146 to 180 = right
  const absAngle = Math.abs(angle);
  if (absAngle < 35) {
    return 'right';
  } else if (absAngle <= 145) {
    return 'center';
  } else {
    return 'left';
  }
}
